import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.sort";
import _defineProperty from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * {
 * precipitation_2h--两小时降雨数据
 * description--一句话描述
 * name--城市名
 * warn_situation--天气概况，大雨
 * warn_line--预警线，用于降雨排序
 * }
 */
import Api from '@/api/localdata-service.js';
import { isArray, cloneDeep, isNumber } from 'lodash';
import WeatherService from '@/api/weather-service-hefeng.js';
var alarm = {
  namespace: true,
  state: {
    alarmDataList: [],
    // 整理完的数据列表
    alarmList: [],
    // 整理完的数据列表
    warnCityList: [],
    // 超过中雨预警的城市列表
    alarmViewChartList: [],
    // 预警可视化数据列表
    warnLineColor: {
      0: '0, 252, 255',
      1: '255, 253, 57',
      2: '255, 135, 38',
      3: '255, 39, 39'
    },
    // 预警等级对应颜色
    alarmCityEmit: false,
    // 用来触发预警城市是否加载完毕
    weatherNow: null // 当前天气数据

  },
  mutations: {
    // 设置预警左侧和右侧数据关联
    SET_ALARM_DATA: function SET_ALARM_DATA(state, data) {}
  },
  actions: {
    initAlarmCityList: function () {
      var _initAlarmCityList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref) {
        var state, _this$state$projectId, projectId, result, radarListShowValue, len, handle, initWarnSituation, renderResult;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = _ref.state;
                _this$state$projectId = this.state.projectId, projectId = _this$state$projectId === void 0 ? '007' : _this$state$projectId;
                _context2.next = 4;
                return Api.GetAlarmCityList(projectId);

              case 4:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _context2.t0 = [];

              case 7:
                result = _context2.t0;
                // 获取雷达测雨站点
                radarListShowValue = true; // 是否展示降雨量

                len = result.length; // 数据长度

                handle = [];

                initWarnSituation = function initWarnSituation(data, bool) {
                  if (!isArray(data)) {
                    throw new Error('输入数组类型');
                  }

                  var value = Math.max.apply(Math, _toConsumableArray(data));
                  var sum = 0;

                  var calcu = function calcu(para1, para2, para3) {
                    if (value < para1) {
                      return {
                        information: '无雨',
                        line: 0
                      };
                    } else if (value >= para1 && value <= para2) {
                      return {
                        information: '小雨',
                        line: 1
                      };
                    } else if (value > para2 && value <= para3) {
                      return {
                        information: '中雨',
                        line: 2
                      };
                    } else if (value > para3) {
                      return {
                        information: '大雨',
                        line: 3
                      };
                    }
                  };

                  sum = data.reduce(function (prev, curr) {
                    return prev + curr;
                  });

                  if (bool) {
                    return _objectSpread(_objectSpread({}, calcu(0.08, 3.44, 11.33)), {}, {
                      sortValue: (sum / 24).toFixed(2),
                      name: value < 0.08 ? '无雨' : (sum / 24).toFixed(2) < 1 ? '小于1mm' : (sum / 24).toFixed(2) + 'mm'
                    });
                  }

                  return calcu(0.03, 0.25, 0.35);
                };

                renderResult = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(arr, i) {
                    var val, res, weather1, daily, minutely, desc, descOneHour, descTwoHour, _state$alarmDataList;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(i >= arr.length)) {
                              _context.next = 4;
                              break;
                            }

                            state.alarmCityEmit = false;

                            if (radarListShowValue) {
                              state.alarmDataList.sort(function (a, b) {
                                return b.sort_value - a.sort_value;
                              }); // const alarmMap = new Map()
                              // state.alarmDataList.forEach((item, index) => {
                              //     if (item.warn_situation !== '无雨' && parseFloat(item.warn_situation.replace('mm', '') < 1)) item.warn_situation = '小于1mm'
                              //     alarmMap.set(item.name, {
                              //         index, name: item.name
                              //     })
                              // })
                              // const alarmDataDeep = cloneDeep(state.alarmList)
                              // state.alarmList.forEach(item => {
                              //     if (item.name === alarmMap.get(item.name).name) {
                              //         alarmDataDeep.splice(alarmMap.get(item.name).index, 1, item)
                              //     }
                              // })
                              // state.alarmList = alarmDataDeep
                            } else state.alarmList.sort(function (a, b) {
                              return b.warn_line - a.warn_line;
                            }); // state.warnCityList = arr.filter(val => val.warn_line >= 2); // 这里筛选出预警城市较大的


                            return _context.abrupt("return");

                          case 4:
                            val = cloneDeep(arr[i]); // 返回降雨量值

                            if (!radarListShowValue) {
                              _context.next = 23;
                              break;
                            }

                            _context.next = 8;
                            return Promise.all([WeatherService.GetHeFengForcast("".concat(val.lng, ",").concat(val.lat)), // 2小时数据
                            WeatherService.GetHeFengForcastData("".concat(val.lng, ",").concat(val.lat)) // 未来7天数据
                            ]);

                          case 8:
                            res = _context.sent;
                            weather1 = res[0];
                            daily = res[1].data.daily;
                            minutely = weather1.data.minutely.map(function (item) {
                              return +item.precip;
                            }); // 拿到分钟级数据

                            desc = initWarnSituation(minutely, true);
                            descOneHour = initWarnSituation(minutely.slice(0, 12), true);
                            descTwoHour = initWarnSituation(minutely.slice(12), true);
                            val.precipitation_2h = minutely; // 预测数据

                            val.description = weather1.data.summary;
                            val.warn_situation_one = descOneHour.name;
                            val.warn_situation_two = descTwoHour.name;
                            val.sort_value = desc.sortValue;
                            val.warn_line = desc.line;
                            val.daily = daily; // 逐天数据

                            val.id = i;

                          case 23:
                            // else { // 返回降雨强度
                            //     const val = cloneDeep(arr[i])
                            //     const weather = await WeatherService.GetCaiYunForcast(`${val.lng},${val.lat}`)
                            //     const minutely = weather.data.result.minutely // 拿到分钟级数据
                            //     const daily = weather.data.result.daily
                            //     const desc = initWarnSituation(minutely.precipitation_2h)
                            //     const descOneHour = initWarnSituation(minutely.precipitation_2h.slice(0, 60))
                            //     const descTwoHour = initWarnSituation(minutely.precipitation_2h.slice(60))
                            //     val.precipitation_2h = minutely.precipitation_2h // 预测数据
                            //     val.precipitation = daily.precipitation // 逐天数据
                            //     val.temperature = daily.temperature // 逐天温度
                            //     val.skycon_d = daily.skycon // 逐天天气现象
                            //     val.skycon_n = daily.skycon_20h_32h
                            //     // val.description = minutely.description // 描述语
                            //     val.description = weather.data.result.forecast_keypoint
                            //     val.warn_situation_one = descOneHour.information
                            //     val.warn_situation_two = descTwoHour.information
                            //     val.warn_line = desc.line
                            //     val.id = i
                            // }

                            /**
                             * 确保优先加载个数在3个以上，因为左侧面板最多容下3个一次性写入比较好
                             */
                            // 前面3条
                            if (len > 3) {
                              if (i <= 2) {
                                handle.push(val);
                              } else {
                                if (i === 3) {
                                  (_state$alarmDataList = state.alarmDataList).push.apply(_state$alarmDataList, handle);
                                }

                                state.alarmDataList.push(val);
                              }
                            } else {
                              state.alarmDataList.push(val);
                            }

                            renderResult(arr, i + 1);

                          case 25:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function renderResult(_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }();

                state.alarmCityEmit = true; // state.alarmList = []

                state.alarmDataList = [];
                renderResult(result, 0);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initAlarmCityList(_x) {
        return _initAlarmCityList.apply(this, arguments);
      }

      return initAlarmCityList;
    }(),
    initWeatherNow: function initWeatherNow(_ref3) {
      var state = _ref3.state;
      var attentionCity = this.state.mapConfig.attentionCity;
      var latlng = "".concat(attentionCity.lng, ",").concat(attentionCity.lat);
      WeatherService.GetCaiyunRealtime(latlng).then(function (res) {
        var result = res.data.now;
        var obj = {
          temperature: isNumber(+result.temp) ? Math.round(+result.temp) : '暂无',
          skycon: result.icon
        };
        state.weatherNow = obj;
      });
    }
  }
};
export default alarm;